/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".studio-privacy-templates-list[_ngcontent-%COMP%]{min-width:480px;max-height:60vh}.studio-privacy-template-row[_ngcontent-%COMP%]{display:flex;align-items:center;margin-bottom:16px}.studio-privacy-template-row[_ngcontent-%COMP%]:last-child{margin-bottom:0}.studio-privacy-template-btn[_ngcontent-%COMP%]{flex-shrink:0;min-width:110px;margin-right:16px}.studio-privacy-template-label[_ngcontent-%COMP%]{flex:1}"];
export { styles as styles };
